module.exports = __webpack_public_path__ + "img/607b8f7.jpg";